'use client';

import type React from 'react';
import { useContext, useEffect, useState } from 'react';
import { jsPDF } from 'jspdf';
import { Buttons } from '../../../../components/ui/button';
import { Badge } from '../../../../components/ui/badge';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../imports/svg-knollny4nu';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomRankingIcon,
  CustomSettingsIcon,
} from '../../../../components/ui/CustomIcons';
// import imgBackground from '/images/background.png';
import { useColor } from '../../../../components/ui/ColorContext';
import ColorPicker from '../../../../components/ui/ColorPicker';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '../../../../components/ui/dialog';
import { Slider } from '../../../../components/ui/slider';
import { ProfileContext } from '../EntirePreview';
import { ScoreContext } from '../GamePreview';

// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

const TakeawayFutureTheme: React.FC<{
  formData: any;
  imageSrc: any;
  getData?: any;
  data?: any;
  preloadedAssets: any;
  gameInfo: any;
  setCurrentScreenId: any;
  FeedbackcurrentPosition: any;
  setFeedbackCurrentPosition: any;
  interactionBlockArray: any;
  profileData: any;
  setFeedbackNavigateNext: any;
  feedbackList: any;
  setInterActionBlockArray: any;
  getFeedbackData: () => void;
  setCurrentQuestNo: any;
  setFirstLoading: any;
}> = ({
  formData,
  imageSrc,
  getData,
  data,
  preloadedAssets,
  gameInfo,
  setCurrentScreenId,
  FeedbackcurrentPosition,
  setFeedbackCurrentPosition,
  interactionBlockArray,
  profileData,
  getFeedbackData,
  setFeedbackNavigateNext,
  setInterActionBlockArray,
  feedbackList,
  setCurrentQuestNo,
  setFirstLoading,
}) => {
  const useData = useContext(ProfileContext);
  const [TakeAwayContentLang, setTakeAwayContentLang] = useState(null);
  const { profile, setProfile } = useContext(ScoreContext);

  const TakeAwayContentLanguage = () => {
    if (profileData?.Audiogetlanguage.length !== 0) {
      const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === formData?.gameId,
      );
      if (GameLanguageFilter.length > 0) {
        const takeAwayFiltered = GameLanguageFilter.filter(
          (key: any) => key?.fieldName === 'gameTakeawayContent',
        );
        if (takeAwayFiltered.length > 0) {
          const TakeAwayContent = takeAwayFiltered[0]?.content
            ? takeAwayFiltered[0]?.content.split('\n')
            : formData?.gameTakeawayContent.split('\n');
          setTakeAwayContentLang(TakeAwayContent);
        }
      }
    } else {
      setTakeAwayContentLang(formData?.gameTakeawayContent?.split('\n'));
    }
  };
  useEffect(() => {
    TakeAwayContentLanguage();
  }, [formData]);
  // useEffect(() =>
  // {
  //   TakeAwayContentLanguage();
  // },[])

  // const content = formData.gameTakeawayContent?.split('\n');
  const previousNavigation = () => {
    useData?.setMotionEffect(true);
    const LastquestNo = parseInt(profile.currentQuest);
    setFirstLoading(false);
    setCurrentQuestNo(LastquestNo);
    setTimeout(() => {
      if (
        formData?.gameIsShowReflectionScreen === 'true' &&
        gameInfo?.reflectionQuestions.length > 0
      ) {
        setCurrentScreenId(3);
        return false;
      } else if (
        feedbackList.length !== 0 &&
        gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
      ) {
        if (
          feedbackList?.find((item: any) => item.quest == profile.currentQuest)
        ) {
          const groupedFeedback: { [key: string]: any[] } = {};
          feedbackList.forEach((feedback: any) => {
            if (!(feedback.Seq in groupedFeedback)) {
              groupedFeedback[feedback.Seq] = [];
            }
            groupedFeedback[feedback.Seq].push(feedback);
          });
          const firstPageFeedback: any[] = [];
          Object.keys(groupedFeedback).forEach((seq: any) => {
            const lastIndex = groupedFeedback[seq].length - 1;
            if (profile.currentQuest == groupedFeedback[seq][lastIndex].quest) {
              firstPageFeedback.push(groupedFeedback[seq][lastIndex]);
            }
          });
          setFeedbackCurrentPosition(firstPageFeedback.length - 1);
          setInterActionBlockArray(firstPageFeedback.length - 1);
          getFeedbackData();
          setFeedbackNavigateNext(false);
          setCurrentScreenId(14); //Navigate to together all feedback
        }
      } else if (formData?.gameIsShowLeaderboard === 'true') {
        setCurrentScreenId(4);
        return false;
      } else {
        setCurrentScreenId(6);
        return false;
      }
    }, 300);
  };
  const handleNext = () => {
    setFirstLoading(true);
    useData?.setMotionEffect(true);
    setTimeout(() => {
      getData(data);
    }, 300);
  };


   const getKeyInsightsLines = (blockText: any): string[] => {
      if (!blockText) return [];

      // If already an array
      if (Array.isArray(blockText)) {
        return blockText;
      }

      // If string → split by line breaks
      if (typeof blockText === "string") {
        return blockText
          .split(/\n+/)
          .map(line => line.trim())
          .filter(Boolean);
      }

      return [];

    };
 
    const handleDownloadPDF = async () => {
      const rawText =
        Array.isArray(TakeAwayContentLang)
          ? TakeAwayContentLang.join('\n')
          : (typeof data?.blockText === 'string' ? data.blockText : '');

      if (!rawText) return;
      const resolveImageToDataUrl = async (rawUrl: string) => {
        try {
          if (!rawUrl) return null;
          if (/^data:/i.test(rawUrl)) {
            const mimeMatch = rawUrl.match(/^data:([^;]+);base64,/i);
            return { dataUrl: rawUrl, mime: mimeMatch ? mimeMatch[1] : 'image/png' };
          }

          let url = rawUrl;

          // Extract actual image URL from Next.js image optimization endpoint
          if (url.includes('/_next/image')) {
            const urlParam = new URL(url).searchParams.get('url');
            if (urlParam) {
              url = decodeURIComponent(urlParam);

            }
          }

          if (url.startsWith('/')) url = window.location.origin + url;
          if (!/^https?:\/\//i.test(url)) url = new URL(url, window.location.href).toString();



          // Try XMLHttpRequest blob approach (better CORS handling)
          try {
            const xhr = await new Promise<Blob | null>((resolve) => {
              const request = new XMLHttpRequest();
              request.open('GET', url, true);
              request.responseType = 'blob';
              request.onload = () => {
                if (request.status === 200 && request.response.type.startsWith('image/')) {
                  resolve(request.response);
                } else {
                  resolve(null);
                }
              };
              request.onerror = () => {

                resolve(null);
              };
              request.timeout = 10000;
              request.ontimeout = () => {

                resolve(null);
              };
              request.send();
            });

            if (xhr) {
              const dataUrl = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result as string);
                reader.onerror = reject;
                reader.readAsDataURL(xhr);
              });
              const mimeMatch = (dataUrl || '').match(/^data:([^;]+);base64,/);
              const mime = mimeMatch ? mimeMatch[1] : (xhr.type || 'image/jpeg');

              return { dataUrl, mime };
            }
          } catch (e) {
         
          }

          // Try fetch with include credentials
          try {
            const res = await fetch(url, {
              mode: 'cors',
              credentials: 'include'
            });

            if (res && res.ok) {
              const blob = await res.blob();
              if (blob.type.startsWith('image/')) {
                const dataUrl = await new Promise<string>((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result as string);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                });
                const mimeMatch = (dataUrl || '').match(/^data:([^;]+);base64,/);
                const mime = mimeMatch ? mimeMatch[1] : (blob.type || 'image/jpeg');

                return { dataUrl, mime };
              }
            }
          } catch (e) {
            console.log('Fetch approach failed:', e);
          }

          // Canvas rendering (with multiple approaches)
          const imageUrl = url;

          // First attempt: with crossOrigin
          const canvasResult1 = await new Promise<{ dataUrl: string; mime: string } | null>((resolve) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            let resolved = false;

            const timeout = setTimeout(() => {
              if (!resolved) {
                resolved = true;
                resolve(null);
              }
            }, 10000);

            img.onload = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                try {
                  const canvas = document.createElement('canvas');
                  canvas.width = img.naturalWidth || img.width || 800;
                  canvas.height = img.naturalHeight || img.height || 600;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    ctx.drawImage(img, 0, 0);
                    const dataUrl = canvas.toDataURL('image/png');

                    resolve({ dataUrl, mime: 'image/png' });
                    return;
                  }
                } catch (err) {
                  console.log('Canvas with CORS error:', err);
                }
                resolve(null);
              }
            };
            img.onerror = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                resolve(null);
              }
            };
            img.src = imageUrl;
          });

          if (canvasResult1) return canvasResult1;

          // Second attempt: without crossOrigin
          const canvasResult2 = await new Promise<{ dataUrl: string; mime: string } | null>((resolve) => {
            const img = new Image();
            let resolved = false;

            const timeout = setTimeout(() => {
              if (!resolved) {
                resolved = true;
                resolve(null);
              }
            }, 10000);

            img.onload = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                try {
                  const canvas = document.createElement('canvas');
                  canvas.width = img.naturalWidth || img.width || 800;
                  canvas.height = img.naturalHeight || img.height || 600;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    ctx.drawImage(img, 0, 0);
                    const dataUrl = canvas.toDataURL('image/png');

                    resolve({ dataUrl, mime: 'image/png' });
                    return;
                  }
                } catch (err) {
                  console.log('Canvas without CORS error:', err);
                }
                resolve(null);
              }
            };
            img.onerror = () => {
              if (!resolved) {
                resolved = true;
                clearTimeout(timeout);
                resolve(null);
              }
            };
            img.src = imageUrl;
          });

          return canvasResult2;
        } catch (err) {
          console.warn('resolveImageToDataUrl failed:', err);
          return null;
        }
      };
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const marginLeft = 15;
      let y = 25;

      // 🎯 Title
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      const title = `${gameInfo.gameData.gameTitle} Takeaways`;
      const titleWidth = doc.getTextWidth(title);
      const centerX = (pageWidth - titleWidth) / 2;
      doc.text(title, centerX, y);
      y += 12;

      // Split content by images, videos and URLs while preserving them (SAME LOGIC AS WEB PAGE)
      const parts = rawText.split(/(<img[^>]*>|<video[^>]*>.*?<\/video>|https?:\/\/[^\s]+)/gi);

      // Process each part in order (SAME LOGIC AS WEB PAGE)
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        // Skip empty parts
        if (!part || !part.trim()) continue;

        // Check if part is an image tag
        const imgMatch = part.match(/<img[^>]*src=["']([^"']+)["'][^>]*>/i);
        // Check if part is a plain URL
        const urlMatch = part.match(/^https?:\/\/[^\s]+$/i);

        if (imgMatch && imgMatch[1]) {
          // Process image from img tag (SAME LOGIC AS WEB PAGE)
          try {
            const imageUrl = imgMatch[1];
            const resolved = await resolveImageToDataUrl(imageUrl);
            if (resolved && resolved.dataUrl) {
              let { dataUrl, mime } = resolved;
              let format: 'PNG' | 'JPEG' = mime && mime.includes('png') ? 'PNG' : 'JPEG';

              if (mime === 'image/svg+xml' && dataUrl) {
                try {
                  const svgImg = new Image();
                  const svgLoaded: Promise<void> = new Promise((resolv) => {
                    svgImg.onload = () => resolv();
                    svgImg.onerror = () => resolv();
                  });
                  svgImg.src = dataUrl;
                  await svgLoaded;
                  const canvas = document.createElement('canvas');
                  canvas.width = svgImg.naturalWidth || 800;
                  canvas.height = svgImg.naturalHeight || 600;
                  const ctx = canvas.getContext('2d');
                  if (ctx) {
                    ctx.drawImage(svgImg, 0, 0, canvas.width, canvas.height);
                    dataUrl = canvas.toDataURL('image/png');
                    format = 'PNG';
                  }
                } catch (err) {
                }
              }

              const imgEl = new Image();
              const imgLoaded: Promise<void> = new Promise((resolv) => {
                imgEl.onload = () => resolv();
                imgEl.onerror = () => resolv();
              });
              imgEl.src = dataUrl as string;
              await imgLoaded;

              const maxWidth = pageWidth - marginLeft * 2;
              const displayW = maxWidth;
              const displayH = imgEl.naturalHeight && imgEl.naturalWidth ? (imgEl.naturalHeight / imgEl.naturalWidth) * displayW : displayW * 0.6;

              if (y + displayH > doc.internal.pageSize.getHeight() - 25) {
                doc.addPage();
                y = 25;
              }

              try {
                doc.addImage(dataUrl as string, format, marginLeft, y, displayW, displayH);
                y += displayH + 8;
              } catch (err) {
                console.warn('addImage failed', err);
              }
            }
          } catch (e) {
            console.warn('Image embed failed', e);
          }
        } else if (urlMatch && urlMatch[0]) {
          // Process plain URL - check type first (video, image, or website)
          try {
            const url = urlMatch[0];

            // Check if URL is a video URL (strict detection - only if clearly a video)
            const isVideoUrl = /\.(mp4|webm|ogg|mov|avi)(\?|$)/i.test(url) ||
              /\/(video|watch|embed)/i.test(url) ||
              /youtube|youtu\.be|vimeo|dailymotion/i.test(url);

            if (isVideoUrl) {
              // Video URL - display as text link only
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(9);
              doc.setTextColor(0, 0, 255); // Blue color for links

              if (y > doc.internal.pageSize.getHeight() - 10) {
                doc.addPage();
                y = 25;
              }

              const shortUrl = url.length > 80 ? url.substring(0, 77) + '...' : url;
              doc.text('Video: ' + shortUrl, marginLeft, y, { maxWidth: pageWidth - marginLeft * 2 });
              doc.setTextColor(0, 0, 0); // Reset to black
              y += 8;
            } else {
              // For all other URLs: Try to download as image first, fallback to website link
              let resolved = null;

              // Try to resolve as image (with retry - 3 attempts with delay)
              for (let attempt = 0; attempt < 3; attempt++) {
                resolved = await resolveImageToDataUrl(url);
                if (resolved && resolved.dataUrl) {

                  break; // Successfully resolved
                }
                // Wait before retry
                if (attempt < 2) {
                  await new Promise(r => setTimeout(r, 500)); // Increased delay to 500ms
                }
              }

              if (resolved && resolved.dataUrl) {
                // Successfully downloaded as image - embed it
                let { dataUrl, mime } = resolved;
                let format: 'PNG' | 'JPEG' = mime && mime.includes('png') ? 'PNG' : 'JPEG';

                const imgEl = new Image();
                const imgLoaded: Promise<void> = new Promise((resolv) => {
                  imgEl.onload = () => resolv();
                  imgEl.onerror = () => resolv();
                });
                imgEl.src = dataUrl as string;
                await imgLoaded;

                const maxWidth = pageWidth - marginLeft * 2;
                const displayW = maxWidth;
                const displayH = imgEl.naturalHeight && imgEl.naturalWidth ? (imgEl.naturalHeight / imgEl.naturalWidth) * displayW : displayW * 0.6;

                if (y + displayH > doc.internal.pageSize.getHeight() - 25) {
                  doc.addPage();
                  y = 25;
                }

                try {
                  doc.addImage(dataUrl as string, format, marginLeft, y, displayW, displayH);
                  y += displayH + 8;
                } catch (err) {
                  console.warn('addImage failed', err);
                }
              } else {
                // Image download failed - display URL as link
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(9);
                doc.setTextColor(0, 0, 255); // Blue color for links

                if (y > doc.internal.pageSize.getHeight() - 10) {
                  doc.addPage();
                  y = 25;
                }

                const shortUrl = url.length > 80 ? url.substring(0, 77) + '...' : url;
                doc.text('Link: ' + shortUrl, marginLeft, y, { maxWidth: pageWidth - marginLeft * 2 });
                doc.setTextColor(0, 0, 0); // Reset to black
                y += 8;
              }
            }
          } catch (e) {
            console.warn('URL processing failed', e);
          }
        } else {
          // Process text content - filter out parts that are too short or just whitespace
          const trimmedPart = part.trim();

          // Skip parts that are just single characters or very short fragments (less than 3 characters)
          if (trimmedPart.length < 3) continue;

          const lines = getKeyInsightsLines(trimmedPart);

          doc.setFont('helvetica', 'normal');
          doc.setFontSize(12);
          doc.setTextColor(0, 0, 0); // Ensure text is black

          lines.forEach((line: any) => {
            const cleanLine = line.replace(/^\s*[\u2022•\-]\s*/, '').trim();
            // Only add bullet if it's actual text content with meaningful length
            if (cleanLine && cleanLine.length > 1) {
              const wrappedText = doc.splitTextToSize(`• ${cleanLine}`, pageWidth - marginLeft * 2);

              if (y > doc.internal.pageSize.getHeight() - 25) {
                doc.addPage();
                y = 25;
              }

              doc.text(wrappedText, marginLeft, y);
              y += wrappedText.length * 8;
            }
          });
        }
      }

      doc.save(`${gameInfo.gameData.gameTitle} Takeaways.pdf`);
    };

    //new by kaviya
    const renderInsightParts = (rawText: any, keyPrefix: string) => {
      if (!rawText) return null;

      const safeText = typeof rawText === "string" ? rawText : String(rawText);

      const parts = safeText.split(
        /(<img[^>]*>|<video[^>]*>.*?<\/video>|https?:\/\/[^\s]+)/gi
      );

      return (
        <div className="flex flex-col gap-3">
          {parts.map((part: string, index: number) => {
            const key = `${keyPrefix}-${index}`;

            const imgMatch = part.match(/<img[^>]*src=["']([^"']+)["'][^>]*>/i);
            const videoMatch = part.match(/<video[^>]*src=["']([^"']+)["'][^>]*>/i);
            const urlMatch = part.match(/^https?:\/\/[^\s]+$/i);

            /* ================= IMAGE TAG ================= */
            if (imgMatch) {
              const imageUrl = imgMatch[1];
              return (
                <div key={key} className="flex justify-center my-3">
                  <img
                    src={imageUrl}
                    alt="content"
                    className="w-full max-w-4xl rounded-lg object-cover"
                    style={{
                      height: "300px",
                      border: `1px solid ${primaryColor}`,
                      boxShadow: `0px 0px 10px rgba(${primaryColor}, 0.3)`
                    }}
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                </div>
              );
            }

            /* ================= VIDEO TAG ================= */
            if (videoMatch) {
              const videoUrl = videoMatch[1];
              return (
                <div key={key} className="flex justify-center my-3">
                  <video
                    src={videoUrl}
                    controls
                    className="max-w-4xl max-h-[300px] rounded-lg"
                    style={{
                      border: `1px solid ${primaryColor}`,
                      boxShadow: `0px 0px 10px rgba(${primaryColor}, 0.3)`
                    }}
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                </div>
              );
            }

            /* ================= URL ================= */
            if (urlMatch) {
              const url = part;

              const isImage =
                /\.(jpg|jpeg|png|gif|webp|svg)(\?|$)/i.test(url);

              const isVideo =
                /\.(mp4|webm|ogg|mov|avi)(\?|$)/i.test(url);

              const isYouTube = /youtube|youtu\.be/i.test(url);

              /* IMAGE URL */
              if (isImage) {
                return (
                  <div key={key} className="flex justify-center my-3">
                    <img
                      src={url}
                      alt="content"
                      className="w-full max-w-4xl rounded-lg object-cover"
                      style={{
                        height: "300px",
                        border: `1px solid ${primaryColor}`,
                        boxShadow: `0px 0px 10px rgba(${primaryColor}, 0.3)`
                      }}
                      onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                  </div>
                );
              }

              /* VIDEO URL */
              if (isVideo) {
                return (
                  <div key={key} className="flex justify-center my-3">
                    <video
                      src={url}
                      controls
                      className="max-w-4xl max-h-[300px] rounded-lg"
                      style={{
                        border: `1px solid ${primaryColor}`,
                        boxShadow: `0px 0px 10px rgba(${primaryColor}, 0.3)`
                      }}
                    />
                  </div>
                );
              }

              /* YOUTUBE */
              if (isYouTube) {
                const videoId = url.match(
                  /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/
                );
                if (videoId) {
                  return (
                    <div key={key} className="flex justify-center my-3">
                      <iframe
                        src={`https://www.youtube.com/embed/${videoId[1]}`}
                        className="w-full max-w-4xl h-[300px] rounded-lg"
                        style={{
                          border: `1px solid ${primaryColor}`,
                          boxShadow: `0px 0px 10px rgba(${primaryColor}, 0.3)`
                        }}
                        allowFullScreen
                      />
                    </div>
                  );
                }
              }

              /* WEBSITE PREVIEW */
              return (
                <div key={key} className="flex justify-center my-3">
                  <div
                    className="w-full max-w-4xl rounded-lg"
                    style={{
                      border: `1px solid ${primaryColor}`,
                      boxShadow: `0px 0px 10px rgba(${primaryColor}, 0.3)`
                    }}
                  >
                    <iframe
                      src={url}
                      className="w-full h-[300px] rounded-lg"
                      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                    />
                  </div>
                </div>
              );
            }

            /* ================= TEXT ================= */
            if (part.trim()) {
              return (
                <span key={key} style={{ color: primaryColor }}>
                  {part}
                </span>
              );
            }

            return null;
          })}
        </div>
      );
    };

 const playClickSound = () => {
            try {
              const audio = new Audio(BtnClickSound as string);
              audio.volume = 1;
              audio.play().catch(() => { });
      
              setTimeout(() => {
                audio.pause();
                audio.currentTime = 0;
              }, 1000);
            } catch (e) {
              // ignore audio errors
            }
          };
  const { primaryColor } = useColor();

  const NavigationArrow: React.FC<{
    direction: 'left' | 'right';
    onClick: () => void;
  }> = ({ direction, onClick }) => {
    return (
      <Buttons
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="rounded-3xl h-10 w-[3.75rem] px-4 py-2 transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(${
            direction === 'left' ? '275.041deg' : '90deg'
          },
                rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
            primaryColor,
          )}, 0.15) 84.803%)`,
          border: `1px solid ${primaryColor}`,
          boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(
            primaryColor,
          )}, 0.3)`,
        }}
      >
        {direction === 'left' ? (
          <ChevronLeft className="!w-4 !h-4 text-white" />
        ) : (
          <ChevronRight className="!w-4 !h-4 text-white" />
        )}
      </Buttons>
    );
  };

  return (
    <div
      className="relative h-screen w-full overflow-hidden bg-black/90 bg-cover bg-center bg-no-repeat"
      // style={{ backgroundImage: `url('${imgBackground}')` }}
    >
      <div className="relative flex h-full w-full px-4 pb-4 sm:px-6 sm:pb-6 lg:px-8 lg:pb-8">
        {/* Top Navigation Bar */}
        <div className="absolute left-0 right-0 top-0 flex h-[5.5rem] items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-6">
           
          </div>
          <div className="flex items-center gap-4">
           
            <Dialog>
              <DialogTrigger asChild>
                <div className="translate-y-1">
                  
                </div>
              </DialogTrigger>
              <DialogContent
                className="rounded-[2rem] border-none px-7 py-6 shadow-lg sm:max-w-2xl"
                style={{
                  background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${hexToRgb(
                    primaryColor,
                  )}, 0.6) 218.68%)`,
                  border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${hexToRgb(
                    primaryColor,
                  )}, 0.4) 188.68%)`,
                  boxShadow: '0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)',
                }}
              >
                <h2
                  className="py-1 text-center text-3xl font-medium"
                  style={{
                    color: primaryColor,
                    textShadow: `0 0 9px rgba(${hexToRgb(primaryColor)}, 0.49)`,
                  }}
                >
                  Settings
                </h2>

                {/* Decorative Line */}
                <div className="relative flex w-full items-center justify-center">
                  <div className="w-full">
                    <div className="relative h-[1px] w-full">
                      <div
                        className="absolute inset-0"
                        style={{
                          background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                          opacity: 0.995,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="mx-auto mb-2 mt-3 flex w-full max-w-md flex-col gap-8 pb-3 pt-5">
                  <div className="flex flex-col gap-10">
                    {/* Music Volume */}
                    <div className="flex flex-col items-center gap-1">
                      <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                        Music Volume
                      </label>
                      <Slider
                        defaultValue={[40]}
                        max={100}
                        step={1}
                        className="w-full"
                        // trackClassName="bg-white/70"
                        // thumbClassName="bg-white border border-gray-300 shadow-sm"
                      />
                    </div>
                    {/* Voice Over Volume */}
                    <div className="flex flex-col items-center gap-1">
                      <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                        Voice over volume
                      </label>
                      <Slider
                        defaultValue={[20]}
                        max={100}
                        step={1}
                        className="w-full"
                        // trackClassName="bg-white/70"
                        // thumbClassName="bg-white border border-gray-300 shadow-sm"
                      />
                    </div>
                    {/* Color Picker */}
                    <div className="flex flex-col items-center gap-1">
                      <label className="font-rubik mb-2 text-2xl font-normal tracking-[-0.005rem] text-white">
                        Set Theme
                      </label>
                      <ColorPicker />
                    </div>
                  </div>

                  {/* Okay button */}
                  <DialogTrigger asChild>
                    <Buttons
                      variant="ghost"
                      size="sm"
                      className="rounded-3xl mx-auto h-11 w-[5.75rem] px-4 py-2 text-lg text-white transition-all duration-200 hover:scale-110 hover:text-white"
                      style={{
                        background: `linear-gradient(275.041deg
                              ,
                                rgba(${hexToRgb(
                                  primaryColor,
                                )}, 0.7) 7.25%, rgba(0, 0, 0, 0.8) 84.803%)`,
                        border: `1px solid ${primaryColor}`,
                        boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
                      }}
                    >
                      Okay
                    </Buttons>
                  </DialogTrigger>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>

        {/* Takeaways Content */}
        <div className="flex-grow flex h-full flex-col items-center justify-center pt-24">
          <div className="relative w-full max-w-[54.875rem] overflow-hidden rounded-[2.375rem] ">
            <div
              className="relative flex h-full max-h-fit w-full max-w-[54.875rem] flex-col items-center justify-start gap-5 overflow-hidden rounded-[2.375rem] px-10 py-8 backdrop-blur-[3.724rem] backdrop-filter"
              style={{
                background: `linear-gradient(21deg, rgba(${hexToRgb(
                  primaryColor,
                )}, 0.05) -10.76%, rgba(${hexToRgb(
                  primaryColor,
                )}, 0.1) 127.18%)`,
              }}
            >
              {/* Takeaways Title */}
              <div className="relative">
                <h1
                  className="text-center text-4xl font-normal tracking-[0.005rem]"
                  style={{
                    color: primaryColor,
                    textShadow: `rgba(${hexToRgb(
                      primaryColor,
                    )}, 0.5) 0px 0px 9px`,
                  }}
                >
                  Takeaways
                </h1>
              </div>

              {/* Decorative Line */}
              <div className="relative flex w-full items-center justify-center">
                <div className="w-full">
                  <div className="relative h-[1px] w-full">
                    <div
                      className="absolute inset-0"
                      style={{
                        background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                        opacity: 0.995,
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Takeaways Content Area */}
              <div className=" flex w-full items-center justify-center overflow-y-auto p-4">
                <div className="mx-auto w-full max-w-4xl overflow-y-auto overflow-x-hidden">
                  <div className="relative">
                    {/* Takeaways List */}
                    <div className="relative z-10 w-full">
                      <div
                        className="font-rubik relative flex w-full flex-col justify-center space-y-4 text-[1.194rem] font-normal leading-relaxed tracking-[-0.09px] text-[#ffffff]"
                      >
                      <div>
                            {TakeAwayContentLang &&
                              TakeAwayContentLang.map((it: any, ind: number) => {
                                // Remove extra bullet characters if present
                                const bulletIndex = it.indexOf('\u2022');
                                const cleanedLine = bulletIndex !== -1 ? it.slice(bulletIndex + 1).trim() : it.trim();

                                if (!cleanedLine) return null;

                                // Split by <h1> to separate main heading and sub-points
                                const parts = cleanedLine.split('<h1>').map((p: string) => p.trim()).filter(Boolean);
                                const mainHeading = parts[0];
                                const subPoints = parts.slice(1);



                                return (
                                  <div key={ind} className="mb-4">
                                    {/* 🔹 Main bullet heading */}
                                    <div className="flex items-start gap-4"
                                    >
                                      <div className="mt-2 flex-shrink-0 rounded-full bg-white" style={{ width: '8px', height: '8px', minWidth: '8px' }}></div>
                                      {/* <span className="flex-1 leading-relaxed font-medium">{mainHeading}</span> */}
                                      <span
                                        className="flex-1 leading-relaxed font-medium"

                                      >{renderInsightParts(mainHeading, `main-${ind}`)}</span>
                                    </div>

                                    {/* 🔸 Sub-bullets (for <h1> parts) */}
                                    {subPoints.length > 0 && (
                                      <div className="ml-8 mt-2 space-y-2">
                                        {subPoints.map((sub: string, subIndex: number) => (
                                          <div
                                            key={subIndex}
                                            className="flex items-start gap-4"

                                          >
                                            <div className="mt-2 flex-shrink-0 rounded-full bg-white opacity-70" style={{ width: '8px', height: '8px', minWidth: '8px' }}></div>
                                            {/* <span className="flex-1 leading-relaxed">{sub}</span> */}
                                            <span className="flex-1 leading-relaxed">   {renderInsightParts(sub, `sub-${ind}-${subIndex}`)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
<div className="absolute bottom-[4.5rem]  z-50"
style={{bottom:'1.8rem',right:'8rem'}}
>
  <Buttons
    onClick={handleDownloadPDF}
    variant="ghost"
    size="sm"
    className="w-[7rem] text-lg h-11 py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110 text-white hover:text-white"
    style={{
      background: `linear-gradient(275.041deg,
        rgba(${hexToRgb(primaryColor)}, 0.7) 7.25%,
        rgba(0, 0, 0, 0.8) 84.803%)`,
      border: `1px solid ${primaryColor}`,
      boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
    }}
  >
    Download
  </Buttons>
</div>
              {/* Bottom Navigation */}
              <div className="flex w-full items-center justify-between">
                <NavigationArrow
                  direction="left"
                  onClick={() =>{ previousNavigation();
                    playClickSound()
                  }

                  }
                />
                <NavigationArrow
                  direction="right"
                  onClick={() => {handleNext()
                    playClickSound()
                  }
                  }
                />
              </div>

              {/* <Box
                position="absolute"
                bottom="3%"
                right="15%"
                zIndex="10"
                className="download-mouse"
              >
                <button
                  onClick={handleDownloadPDF}
                  className="download-btntakeaway"
                >
                  <Img
                    src={download}
                    alt="Download"
                    w={{ base: '72px', md: '90px' }}
                  />
                </button>
              </Box> */}

              {/* Inset Shadow Border */}
              <div
                className="pointer-events-none absolute inset-0 rounded-[2.375rem]"
                style={{
                  boxShadow: `0px 0px 11px 0px inset ${primaryColor}`,
                }}
              />
            </div>
            {/* Additional Background Ellipses */}
            <div className="pointer-events-none absolute left-[30.092rem] top-[0.428rem] flex h-[27.69rem] w-[31.188rem] items-center justify-center mix-blend-lighten">
              <div className="flex-none rotate-[33.283deg]">
                <div className="relative h-[15.169rem] w-[27.352rem]">
                  <div className="absolute bottom-[-167.188%] left-[-92.72%] right-[-92.72%] top-[-167.188%]">
                    <svg
                      className="block w-full h-full"
                      fill="none"
                      preserveAspectRatio="none"
                      viewBox="0 0 1250 1055"
                    >
                      <g
                        filter={`url(#filter_takeaways_1_${primaryColor.replace(
                          '#',
                          '',
                        )})`}
                        opacity="0.2"
                        style={{ mixBlendMode: 'lighten' }}
                      >
                        <ellipse
                          cx="624.819"
                          cy="527.354"
                          fill={primaryColor}
                          rx="218.819"
                          ry="121.354"
                        />
                      </g>
                      <defs>
                        <filter
                          colorInterpolationFilters="sRGB"
                          filterUnits="userSpaceOnUse"
                          height="1054.26"
                          id={`filter_takeaways_1_${primaryColor.replace(
                            '#',
                            '',
                          )}`}
                          width="1249.19"
                          x="0.223328"
                          y="0.223328"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            mode="normal"
                            result="shape"
                          />
                          <feGaussianBlur
                            result="effect1_foregroundBlur"
                            stdDeviation="202.888"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="pointer-events-none absolute left-[-12.004rem] top-[1.433rem] flex h-[27.69rem] w-[31.188rem] items-center justify-center mix-blend-lighten">
              <div className="flex-none rotate-[33.283deg]">
                <div className="relative h-[15.169rem] w-[27.352rem]">
                  <div className="absolute bottom-[-167.188%] left-[-92.72%] right-[-92.72%] top-[-167.188%]">
                    <svg
                      className="block w-full h-full"
                      fill="none"
                      preserveAspectRatio="none"
                      viewBox="0 0 1250 1055"
                    >
                      <g
                        filter={`url(#filter_takeaways_2_${primaryColor.replace(
                          '#',
                          '',
                        )})`}
                        opacity="0.06"
                        style={{ mixBlendMode: 'lighten' }}
                      >
                        <ellipse
                          cx="624.819"
                          cy="527.354"
                          fill={primaryColor}
                          rx="218.819"
                          ry="121.354"
                        />
                      </g>
                      <defs>
                        <filter
                          colorInterpolationFilters="sRGB"
                          filterUnits="userSpaceOnUse"
                          height="1054.26"
                          id={`filter_takeaways_2_${primaryColor.replace(
                            '#',
                            '',
                          )}`}
                          width="1249.19"
                          x="0.223328"
                          y="0.223328"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            mode="normal"
                            result="shape"
                          />
                          <feGaussianBlur
                            result="effect1_foregroundBlur"
                            stdDeviation="202.888"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            {/* Background Effects */}
            <div className="pointer-events-none absolute -right-[5rem] -top-[5rem] h-[25rem] w-[30.75rem] opacity-20 mix-blend-exclusion">
              <div
                className="absolute inset-0 rounded-full blur-[9.375rem]"
                style={{
                  background: primaryColor,
                  transform: 'scale(0.8)',
                }}
              />
            </div>
            <div className="left pointer-events-none absolute -top-[7.5rem] h-[25rem] w-[30.75rem] opacity-15 mix-blend-exclusion">
              <div
                className="absolute inset-0 rounded-full blur-[9.375rem]"
                style={{
                  background: primaryColor,
                  transform: 'scale(0.8)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



export default TakeawayFutureTheme;
